import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  SiniestrosService,
  Siniestro,
} from "../../../../../shared/services/siniestrosViales.service";
import { TipoSiniestroService } from "../../../../../shared/services/tipo-siniestro.service";
import Swal from "sweetalert2";
import { NivelSeveridadService } from "../../../../../shared/services/nivel-severidad.service";
import { DataService } from "../../../../../shared/services/municipios.service";
import { TipoViaService } from "../../../../../shared/services/tipo-via.service";
import { CondicionesClimaticasService } from "../../../../../shared/services/condiciones-climaticas.service";
import { RelacionService } from "../../../../../shared/services/relacion.service";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";
import { TiposService } from "../../../../../shared/services/tipos.service";
import {
  ConductoresSiniestrosVialesService,
  ConductorSiniestro,
} from "../../../../../shared/services/conductores-siniestros-viales.service";
import { ConductorVehiculoService } from "../../../../../shared/services/conductor.service";
import { TipoDocumentoService } from "../../../../../shared/services/tipodocumento.service";
import { MarcaService } from "../../../../../shared/services/marca.service";
import { ModelosService } from "../../../../../shared/services/modelos.service";
import { EstadoConductorService } from "../../../../../shared/services/estado-conductor.service";
import {
  VehiculoInvolucrado,
  VehiculoInvolucradoService,
} from "../../../../../shared/services/vehiculo-involucrado.service";
import {
  OtrosInvolucrado,
  OtrosInvolucradosService,
} from "../../../../../shared/services/otros-involucrados.service";
import { TipoActorVialService } from "../../../../../shared/services/tipo-actor-vial.service";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { DigitalesService } from "../../../../../shared/services/digitales.service";
import { HttpEventType } from "@angular/common/http";
import { Administracion } from "../../../../../shared/model/administracion.model";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-siniestros-viales-crear",
  templateUrl: "./siniestros-viales-crear.component.html",
  styleUrls: ["./siniestros-viales-crear.component.scss"],
})
export class SiniestrosVialesCrearComponent implements OnInit {
  formSiniestro!: FormGroup;
  tiposSiniestro: any[] = [];
  nivelesSeveridad: any[] = [];
  paises = [{ id: 1, nombre: "Colombia" }];
  departamentos: any[] = [];
  municipios: any[] = [];
  condicionesClimaticas: any[] = [];
  conductoresPorPlaca: any[] = [];
  tiposVehiculo: any[] = [];
  propiedadesVehiculo: any[] = [];
  vias: any[] = [];
  mapUrl: string = "";
  next_id: number | null = null;
  hoy: string | undefined;
  opcionesSiNo = [
    { id: 1, descripcion: "Sí" },
    { id: 0, descripcion: "No" },
  ];

  public Tiposdocumentos = [
    { value: "NIT", label: "NIT" },
    { value: "CC", label: "CEDULA DE CIUDADANIA" },
    { value: "CE", label: "CEDULA DE EXTRANJERIA" },
    { value: "PA", label: "PASAPORTE" },
    { value: "OTRO", label: "OTRO" },
  ];

  public Categoria = [
    { value: "1", label: "MOTOS", disabled: true },
    { value: "A1", label: "A1" },
    { value: "A2", label: "A2" },

    { value: "4", label: "SERVICIO PARTICULAR", disabled: true },
    { value: "B1", label: "B1" },
    { value: "B2", label: "B2" },
    { value: "B3", label: "B3" },

    { value: "8", label: "SERVICIO PUBLICO", disabled: true },
    { value: "C1", label: "C1" },
    { value: "C2", label: "C2" },
    { value: "C3", label: "C3" },

    { value: "12", label: "TRANSPORTE FLUVIAL", disabled: true },
    { value: "TRIPULANTE MOTORISTA", label: "TRIPULANTE MOTORISTA" },
    {
      value: "TRIPULANTE AYUDANTE FLUVIAL",
      label: "TRIPULANTE AYUDANTE FLUVIAL",
    },
    { value: "NO TIENE", label: "NO TIENE" },
  ];

  public RolSiniestro = [
    { value: "1", label: "RESPONSABLE" },
    { value: "2", label: "PRESUNTO RESPONSABLE" },
    { value: "3", label: "NO RESPONSABLE" },
  ];
  marcasVehiculo: any[] = [];
  modelosVehiculo: any[] = [];
  estadoConductor: any[] = [];
  formVehiculoInvolucrado!: FormGroup;
  formConductorInvolucrado!: FormGroup;
  formOtrosInvolucrado!: FormGroup;
  vehiculosInvolucrados: VehiculoInvolucrado[] = [];
  conductoresInvolucrados: ConductorSiniestro[] = [];
  otrosInvolucrados: OtrosInvolucrado[] = [];
  tiposActorVial: any[] = [];
  administraciones: Administracion[] = [];

  constructor(
    private fb: FormBuilder,
    private siniestrosService: SiniestrosService,
    private tipoSiniestroService: TipoSiniestroService,
    private nivelSeveridadService: NivelSeveridadService,
    private digitalesService: DigitalesService,
    private administracionesServices: AdministracionService,
    private condicionesClimaticasService: CondicionesClimaticasService,
    private conductoresSiniestrosVialesService: ConductoresSiniestrosVialesService,
    private tiposService: TiposService,
    private conductorVehiculoService: ConductorVehiculoService,
    private VehiculosService: VehiclesService,
    private vehiculoInvolucradoService: VehiculoInvolucradoService,
    private otrosInvolucradosService: OtrosInvolucradosService,
    private tipoActorVialService: TipoActorVialService,
    private marcaService: MarcaService,
    private estadoConductorService: EstadoConductorService,
    private modeloService: ModelosService,
    private relacionService: RelacionService,
    private tipoviaService: TipoViaService,
    private dataService: DataService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.initFormvVehiculoInvolucrado();
    this.initFormvConductorInvolucrado();
    this.initFormOtrosInvolucrado();
    this.cargarCatalogos();
    this.getDatos();
    this.cargarProximoId();
    this.cargarDataAdmin();

    const fecha = new Date();
    this.hoy = fecha.toISOString().split("T")[0];
  }

  private initForm(): void {
    this.formSiniestro = this.fb.group({
      consecutivo: [{ value: "", disabled: true }], // autogenerado, no editable
      fecha_siniestro: ["", Validators.required],
      hora_siniestro: ["", Validators.required],
      fecha_reporte: ["", Validators.required],
      hora_reporte: ["", Validators.required],
      tipo_siniestro: [null, Validators.required],
      nivel_severidad: [null, Validators.required],
      lesionados: [0, [Validators.min(0)]], // permite 0
      fatalidad: [0, [Validators.min(0)]], // permite 0
      numero_victimas: [0, [Validators.min(0)]],
      descripcion_ocurrido: [
        "",
        [Validators.required, Validators.maxLength(1000)],
      ],
      pais: ["COLOMBIA"],
      departamento: [null, Validators.required],
      municipio: [null, Validators.required],
      direccion_referencia: ["", Validators.required],
      coordenadas_latitud: [""],
      coordenadas_longitud: [""],
      ruta_trayecto: [""],
      via: [null],
      condiciones_climaticas: [null],
      placa: ["", [Validators.required, Validators.maxLength(7)]],
      tipo_vehiculo: [null, Validators.required],
      marca: [null, Validators.required],
      linea: [""],
      modelo: [null],
      propiedad_vehiculo: [null, Validators.required],
      estado: [1],
    });
  }

  private initFormvConductorInvolucrado(): void {
    this.formConductorInvolucrado = this.fb.group({
      nombre: [null, Validators.required],
      tipodocumento: [null],
      n_documento: [null, Validators.required],
      rol_siniestro: [null, Validators.required],
      fecha_nacimiento: ["", Validators.required],
      estado_momento_siniestro: [null, Validators.required],
      categoria: [null, Validators.required],
      n_licencia: [""],
      fecha_expedicion: [""],
      fecha_vencimiento: [""],
      usaba_cinturon: [0],
      mision_laboral: [0],
    });
  }

  private initFormvVehiculoInvolucrado(): void {
    this.formVehiculoInvolucrado = this.fb.group({
      placa_involucrado: [null, Validators.required],
      numero_interno: [null],
      tipo_vehiculo: [null, Validators.required],
      propiedad_vehiculo: [null, Validators.required],
      fecha_vencimiento: [null, Validators.required],
      revision_tecnomecanica: [null, Validators.required],
      carga: [0, [Validators.min(0)]],
      descripcion_carga: [null],
      empresa_transportadora: [null],
    });
  }

  private initFormOtrosInvolucrado(): void {
    this.formOtrosInvolucrado = this.fb.group({
      tipo_actor_vial: [null, Validators.required],
      nombre: ["", Validators.required],
      n_documento: [null, Validators.required],
      placa: ["", Validators.required],
      lesiones: [0, [Validators.min(0)]],
      danos: [0, [Validators.min(0)]],
    });
  }

  private cargarCatalogos(): void {
    this.cargarTipoSiniestro();
    this.cargarNivelesSeveridad();
    this.cargarTiposVia();
    this.cargarCondicionesClimaticas();
    this.cargarTiposVehiculo();
    this.cargarRelaciones();
    this.CargarMarca();
    this.CargarModelo();
    this.cargarEstadoConductor();
    this.cargarTiposActorVial();
  }

  cargarTipoSiniestro(): void {
    this.tipoSiniestroService.getAllTipoSiniestroActivos().subscribe({
      next: (tipos) => (this.tiposSiniestro = tipos),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de siniestro",
          "error",
        ),
    });
  }

  cargarEstadoConductor(): void {
    this.estadoConductorService.getEstados().subscribe({
      next: (estadoConductores) => (this.estadoConductor = estadoConductores),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los estados del conductor",
          "error",
        ),
    });
  }

  cargarNivelesSeveridad(): void {
    this.nivelSeveridadService.getAllNivelSeveridadActivos().subscribe({
      next: (niveles) => (this.nivelesSeveridad = niveles),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los niveles de severidad",
          "error",
        ),
    });
  }

  cargarTiposVia(): void {
    this.tipoviaService.getAllTipoViaActivos().subscribe({
      next: (tipos) => (this.vias = tipos),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de vía",
          "error",
        ),
    });
  }

  cargarTiposActorVial(): void {
    this.tipoActorVialService.getTiposActorVialActivos().subscribe({
      next: (tiposActorVial) => (this.tiposActorVial = tiposActorVial),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de actor vial",
          "error",
        ),
    });
  }

  getDatos(): void {
    this.dataService.getDatos().subscribe({
      next: (datos) => {
        this.municipios = datos;
        this.departamentos = Array.from(
          new Map(
            datos.map((m) => [
              m.departamento.id_departamento,
              {
                id: m.departamento.id_departamento,
                nombre: m.departamento.nombre,
              },
            ]),
          ).values(),
        );
      },
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los municipios",
          "error",
        ),
    });
  }

  cargarCondicionesClimaticas(): void {
    this.condicionesClimaticasService
      .getAllCondicionesClimaticasActivas()
      .subscribe({
        next: (condiciones) => (this.condicionesClimaticas = condiciones),
        error: () =>
          this.mostrarAlerta(
            "Error",
            "No se pudieron cargar las condiciones climáticas",
            "error",
          ),
      });
  }

  cargarTiposVehiculo(): void {
    this.tiposService.getTipos().subscribe({
      next: (tipos) => (this.tiposVehiculo = tipos),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de vehículo",
          "error",
        ),
    });
  }

  cargarRelaciones(): void {
    this.relacionService.getRelaciones().subscribe({
      next: (relaciones) => (this.propiedadesVehiculo = relaciones),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar las relaciones del vehículo",
          "error",
        ),
    });
  }

  CargarMarca(): void {
    this.marcaService.getMarcas().subscribe({
      next: (marca) => (this.marcasVehiculo = marca),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar las marcas de vehículo",
          "error",
        ),
    });
  }

  CargarModelo(): void {
    this.modeloService.getModelos().subscribe({
      next: (modelo) => (this.modelosVehiculo = modelo),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los modelos de vehículo",
          "error",
        ),
    });
  }

  onMunicipioChange(municipioSeleccionado: any): void {
    if (municipioSeleccionado?.departamento) {
      this.formSiniestro.patchValue({
        departamento: municipioSeleccionado.departamento.id_departamento,
      });
    }
  }

  private mensajesRequeridos: Record<string, string> = {
    fecha_siniestro: "Ingresa una fecha de siniestro",
    hora_siniestro: "Ingresa una hora de siniestro",
    fecha_reporte: "Ingresa una fecha de reporte",
    hora_reporte: "Ingresa una hora de reporte",
    tipo_siniestro: "Selecciona un tipo de siniestro",
    nivel_severidad: "Selecciona un nivel de severidad",
    lesionados: "Ingresa el número de lesionados",
    fatalidad: "Ingresa el número de fatalidades",
    numero_victimas: "Ingresa el número de víctimas",
    descripcion_ocurrido: "Ingresa la descripción del siniestro",
    municipio: "Selecciona el municipio",
    departamento: "Selecciona el departamento",
    direccion_referencia: "Ingresa la dirección de referencia",
    placa: "Ingresa la placa",
    tipo_vehiculo: "Ingresa el tipo de vehículo",
    nombre: "Selecciona el conductor",
    tipodocumento: "Selecciona el tipo de documento",
    n_documento: "Ingresa el número de documento",
    rol_siniestro: "Selecciona el rol del siniestro",
    fecha_nacimiento: "Ingresa la fecha de nacimiento",
    estado_momento_siniestro: "Selecciona el estado del momento del siniestro",
    categoria: "Selecciona la categoría",
    n_licencia: "Ingresa el número de licencia",
    fecha_expedicion: "Ingresa la fecha de expedición",
    fecha_vencimiento: "Ingresa la fecha de vencimiento",
    usaba_cinturon: "Selecciona si usaba cinturón de seguridad",
    mision_laboral: "Selecciona la misión laboral",
  };

  private validarCamposRequeridos(): boolean {
    for (const [campo, mensaje] of Object.entries(this.mensajesRequeridos)) {
      const control = this.formSiniestro.get(campo);

      if (
        control &&
        (control.value === null ||
          control.value === "" ||
          control.value === undefined)
      ) {
        // marcar el control como tocado para que se pinte en rojo
        control.markAsTouched();

        // mostrar alerta
        this.mostrarAlerta("Campo requerido", mensaje, "info");

        // hacer scroll al campo y darle foco
        const elemento = document.querySelector(`[formControlName="${campo}"]`);
        if (elemento) {
          (elemento as HTMLElement).scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          (elemento as HTMLElement).focus();
        }

        // 🔹 detener aquí: no sigue bajando a otros campos
        return false;
      }
    }
    return true;
  }

  guardar(): void {
    if (!this.validarCamposRequeridos()) return;

    if (this.conductoresInvolucrados.length === 0) {
      Swal.fire(
        "Campos incompletos",
        "Debe agregar mínimo un conductor involucrado",
        "warning",
      );
      return;
    }

    if (this.vehiculosInvolucrados.length === 0) {
      Swal.fire(
        "Campos incompletos",
        "Debe agregar mínimo un vehículo involucrado",
        "warning",
      );
      return;
    }

    const payloadSiniestro: Siniestro = this.formSiniestro.getRawValue();

    this.siniestrosService.createSiniestro(payloadSiniestro).subscribe({
      next: (siniestroCreado) => {
        if (this.archivosSeleccionados.length > 0) {
          this.subirDocumentos(siniestroCreado.id);
        }

        const conductores = this.conductoresInvolucrados.map((c) => ({
          ...c,
          id_siniestro: siniestroCreado.id,
        }));

        this.conductoresSiniestrosVialesService
          .createConductor(conductores)
          .subscribe({
            next: () => {
              const vehiculos = this.vehiculosInvolucrados.map((v) => ({
                ...v,
                id_siniestro: siniestroCreado.id,
              }));

              this.vehiculoInvolucradoService
                .createVehiculos(vehiculos)
                .subscribe({
                  next: () => {
                    const otros = this.otrosInvolucrados.map((o) => ({
                      id_siniestro: siniestroCreado.id,
                      tipo_actor_vial: o.tipo_actor_vial,
                      nombre: o.nombre,
                      n_documento: o.n_documento,
                      placa: o.placa,
                      lesiones: o.lesiones,
                      danos: o.danos,
                      estado: o.estado ?? 1,
                    }));

                    this.otrosInvolucradosService.create(otros).subscribe({
                      next: () => {
                        Swal.fire({
                          title: "Éxito",
                          text: "Siniestro, conductor, vehículo y otros involucrados registrados correctamente",
                          icon: "success",
                          confirmButtonText: "Aceptar",
                        });

                        this.formSiniestro.reset({
                          consecutivo: "",
                          lesionados: 0,
                          fatalidad: 0,
                          numero_victimas: 0,
                          pais: "COLOMBIA",
                          estado: 1,
                        });

                        this.formVehiculoInvolucrado.reset();
                        this.formConductorInvolucrado.reset();
                        this.formOtrosInvolucrado.reset();
                        this.vehiculosInvolucrados = [];
                        this.conductoresInvolucrados = [];
                        this.otrosInvolucrados = [];
                        this.cargarProximoId();
                      },
                      error: (err) => {
                        this.mostrarAlerta(
                          "Error",
                          err.error?.message ||
                            "No se pudo registrar otros involucrados",
                          "error",
                        );
                      },
                    });
                  },
                  error: (err) => {
                    this.mostrarAlerta(
                      "Error",
                      err.error?.message || "No se pudo registrar el vehículo",
                      "error",
                    );
                  },
                });
            },
            error: (err) => {
              this.mostrarAlerta(
                "Error",
                err.error?.message || "No se pudo registrar el conductor",
                "error",
              );
            },
          });
      },
      error: (err) => {
        this.mostrarAlerta(
          "Error",
          err.error?.message || "No se pudo registrar el siniestro",
          "error",
        );
      },
    });
  }

  updateMap(): void {
    const lat = this.formSiniestro.get("coordenadas_latitud")?.value;
    const lng = this.formSiniestro.get("coordenadas_longitud")?.value;

    if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
      this.mapUrl = `https://www.google.com/maps?q=${lat},${lng}&output=embed`;
    } else {
      this.mapUrl = "";
    }
  }

  cargarProximoId(): void {
    this.siniestrosService.getNextSiniestroId().subscribe({
      next: (resp) => {
        this.next_id = resp.consecutivo;
        this.formSiniestro.patchValue({
          consecutivo: this.next_id?.toString(),
        });
      },
      error: () =>
        this.mostrarAlerta("Error", "No se pudo cargar el próximo id", "error"),
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any): void {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  buscarVehiculoPorPlaca(): void {
    let placa = this.formSiniestro.get("placa")?.value;
    if (!placa) {
      this.mostrarAlerta("Error", "Debes ingresar una placa", "error");
      return;
    }

    placa = placa.toUpperCase();
    this.formSiniestro.patchValue({ placa });

    // 1️⃣ Buscar vehículo
    this.VehiculosService.getPlacasBySiniestro(placa).subscribe({
      next: (vehiculo) => {
        // buscar modelo por id
        const modeloEncontrado = this.modelosVehiculo.find(
          (m) => m.modelo === vehiculo.modelo,
        );

        this.formSiniestro.patchValue({
          tipo_vehiculo: vehiculo.clase,
          marca: vehiculo.marca,
          linea: vehiculo.linea,
          modelo: modeloEncontrado ? modeloEncontrado.id : null,
          propiedad_vehiculo: vehiculo.relacion,
        });
      },
      error: () => {
        this.mostrarAlerta(
          "Error",
          "No se encontró vehículo con esa placa",
          "error",
        );
      },
    });

    // 2️⃣ Buscar conductores asociados
    this.conductorVehiculoService.getConductoresPorPlaca(placa).subscribe({
      next: (conductores) => {
        this.conductoresPorPlaca = conductores.map((conductor) => ({
          ...conductor,
          nombreCompleto: [
            conductor.propietario?.primernombre,
            conductor.propietario?.segundonombre,
            conductor.propietario?.papellidos,
            conductor.propietario?.seapellidos,
          ]
            .filter((parte) => !!parte)
            .join(" ")
            .trim(),
        }));
      },
      error: () => {
        this.mostrarAlerta(
          "Error",
          "No se pudieron obtener los conductores",
          "error",
        );
      },
    });
  }

  onConductorSeleccionado(conductor: any): void {
    const conductorSeleccionado = conductor?.propietario
      ? conductor
      : this.conductoresPorPlaca.find(
          (item) => item.nombreCompleto === conductor,
        );

    if (conductorSeleccionado?.propietario) {
      this.formConductorInvolucrado.patchValue({
        nombre: conductorSeleccionado.nombreCompleto,
        tipodocumento: conductorSeleccionado.propietario.tipo,
        n_documento: conductorSeleccionado.conductor_id,
        rol_siniestro: conductorSeleccionado.rol_siniestro,
        fecha_nacimiento: conductorSeleccionado.propietario.fechanace,
        fecha_expedicion: conductorSeleccionado.propietario.expediciolic,
        categoria: conductorSeleccionado.propietario.categoria,
        n_licencia: conductorSeleccionado.propietario.numerolic,
        fecha_vencimiento: conductorSeleccionado.propietario.vencelic,
        estado_momento_siniestro:
          conductorSeleccionado.estado_momento_siniestro,
        usaba_cinturon: conductorSeleccionado.usaba_cinturon,
        mision_laboral: conductorSeleccionado.mision_laboral,
      });
    }
  }

  private mensajesRequeridosInvolucrados: Record<string, string> = {
    placa_involucrado: "Ingresa la placa del vehículo involucrado",
    tipo_vehiculo: "Selecciona el tipo de vehículo",
    propiedad_vehiculo: "Selecciona la propiedad del vehículo",
    fecha_vencimiento: "Ingresa la fecha de vencimiento del SOAT",
    revision_tecnomecanica: "Ingresa la fecha de revisión tecnomecánica",
  };

  private validarCamposRequeridosInvolucrados(): boolean {
    for (const [campo, mensaje] of Object.entries(
      this.mensajesRequeridosInvolucrados,
    )) {
      const control = this.formVehiculoInvolucrado.get(campo);

      if (
        control &&
        (control.value === null ||
          control.value === "" ||
          control.value === undefined)
      ) {
        control.markAsTouched();
        this.mostrarAlerta("Campo requerido", mensaje, "info");

        const elemento = document.querySelector(`[formControlName="${campo}"]`);
        if (elemento) {
          (elemento as HTMLElement).scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          (elemento as HTMLElement).focus();
        }

        return false;
      }
    }
    return true;
  }

  agregarVehiculo(): void {
    if (!this.validarCamposRequeridosInvolucrados()) return;
    if (this.formVehiculoInvolucrado.invalid) {
      this.formVehiculoInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del vehículo antes de agregarlo",
        "warning",
      );
      return;
    }
    const vehiculo = this.formVehiculoInvolucrado.getRawValue();
    if (vehiculo.placa_involucrado) {
      vehiculo.placa_involucrado = vehiculo.placa_involucrado.toUpperCase();
    }
    const vehiculoGuardar = {
      ...vehiculo,
      placa: vehiculo.placa_involucrado,
    };
    delete vehiculoGuardar.placa_involucrado;
    const existe = this.vehiculosInvolucrados.some(
      (v) => v.placa === vehiculoGuardar.placa,
    );

    if (existe) {
      Swal.fire(
        "Vehículo duplicado",
        "Ya existe un vehículo con esa placa",
        "warning",
      );
      return;
    }

    this.vehiculosInvolucrados.push(vehiculoGuardar);
    this.formVehiculoInvolucrado.reset({ carga: 0 });
    Swal.fire(
      "Vehículo agregado",
      "El vehículo fue agregado correctamente",
      "success",
    );
  }

  eliminarVehiculo(index: number) {
    this.vehiculosInvolucrados.splice(index, 1);
    Swal.fire("Eliminado", "Vehículo eliminado del listado", "success");
  }

  getNombreTipoVehiculo(id: any): string {
    const tipo = this.tiposVehiculo.find((t) => t.idTipos == id);
    return tipo ? tipo.tipos : "";
  }

  getNombrePropiedadVehiculo(id: any): string {
    const propiedad = this.propiedadesVehiculo.find((p) => p.id == id);
    return propiedad ? propiedad.relacion : "";
  }

  agregarConductor(): void {
    if (this.formConductorInvolucrado.invalid) {
      this.formConductorInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del conductor",
        "warning",
      );
      return;
    }

    const conductor = this.formConductorInvolucrado.getRawValue();

    const existe = this.conductoresInvolucrados.some(
      (c) => c.n_documento === conductor.n_documento,
    );

    if (existe) {
      Swal.fire(
        "Conductor duplicado",
        "Ya existe un conductor con ese documento",
        "warning",
      );
      return;
    }

    this.conductoresInvolucrados.push(conductor);
    this.formConductorInvolucrado.reset();
    Swal.fire(
      "Conductor agregado",
      "El conductor fue agregado correctamente",
      "success",
    );
  }

  agregarOtroInvolucrado(): void {
    if (this.formOtrosInvolucrado.invalid) {
      this.formOtrosInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del otro involucrado",
        "warning",
      );
      return;
    }

    const otro = this.formOtrosInvolucrado.getRawValue();
    const otroParaGuardar: OtrosInvolucrado = {
      ...otro,
      nombre: otro.nombre?.trim(),
      placa: otro.placa?.trim().toUpperCase(),
      danos: otro.danos,
    };

    const existe = this.otrosInvolucrados.some(
      (item) =>
        item.n_documento === otroParaGuardar.n_documento &&
        item.placa === otroParaGuardar.placa,
    );

    if (existe) {
      Swal.fire(
        "Otro involucrado duplicado",
        "Ya existe un registro con ese documento y placa",
        "warning",
      );
      return;
    }

    this.otrosInvolucrados.push(otroParaGuardar);
    this.formOtrosInvolucrado.reset({ lesiones: 0, danos: 0 });
    Swal.fire(
      "Otro involucrado agregado",
      "El registro fue agregado correctamente",
      "success",
    );
  }

  eliminarOtroInvolucrado(index: number): void {
    this.otrosInvolucrados.splice(index, 1);
    Swal.fire("Eliminado", "Registro eliminado del listado", "success");
  }

  archivoSeleccionado!: File | null;
  preview: any = null;
  esImagen = false;

  archivosSeleccionados: File[] = [];
  previews: any[] = [];

  onFileSelected(event: any) {
    const file = event.target.files[0] as File;
    if (!file) return;

    this.archivosSeleccionados.push(file);

    if (file.type.startsWith("image")) {
      const reader = new FileReader();
      reader.onload = () => this.previews.push(reader.result);
      reader.readAsDataURL(file);
    } else {
      this.previews.push(null);
    }

    event.target.value = "";
  }

  eliminarDocumento(index: number) {
    this.archivosSeleccionados.splice(index, 1);
    this.previews.splice(index, 1);
  }

  subirDocumentos(idSiniestro: number): void {
    const placa = this.formSiniestro.get("placa")?.value?.toUpperCase();
    const carpeta = `${this.administraciones[0].nit}/pesv/siniestro/${placa}/${idSiniestro}`;

    this.archivosSeleccionados.forEach((archivo, index) => {
      const nombreArchivo = `${idSiniestro}_${index + 1}`;
      this.digitalesService
        .subirDocumentoSiniestro(
          archivo,
          idSiniestro,
          carpeta,
          index,
          "soporte",
        )
        .subscribe({
          next: () =>
            console.log(`Documento ${index + 1} cargado correctamente`),
          error: (err) =>
            console.error(`Error al subir documento ${index + 1}:`, err),
        });
    });
  }

  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        console.log(data);
        this.administraciones = data;
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }
}
